import { ref } from 'vue';
import type { Ref } from 'vue';

type UseToggleReturnType = {
  active: Ref<boolean>;
  toggle: (value?: boolean) => void;
};

export function useToggle(initialValue = false): UseToggleReturnType {
  const active = ref<boolean>(initialValue);

  const toggle: UseToggleReturnType['toggle'] = (value) => {
    active.value = value ?? !active.value;
  };

  return { active, toggle };
}
